import { render, staticRenderFns } from "./person.vue?vue&type=template&id=49c02c45&"
import script from "./person.vue?vue&type=script&lang=js&"
export * from "./person.vue?vue&type=script&lang=js&"
import style0 from "./person.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomePageNavbar: require('/workspace/components/HomePage/HomePageNavbar.vue').default,HomePageFooter: require('/workspace/components/HomePage/HomePageFooter.vue').default})
